export const casing = (string, format) => {
  // Many single-word strings are duplicates that have difference casings.
  // Multi-word strings are generally expected to be formatted correctly already.
  const base = string.toLowerCase();
  let result;
  switch (format) {
    case "upper":
      result = base.toUpperCase();
      break;
    case "lower":
      break;
    case "capitalizeFirst":
      result = base.charAt(0).toUpperCase() + base.slice(1);
      break;
  }
  return result;
};

export const template = (string, templates) => {
  let newString = string;
  const keys = Object.keys(templates);
  keys.forEach((key) => {
    const regex = new RegExp(`#{${key.toUpperCase()}}#`, "g");
    newString = newString.replace(regex, templates[key]);
  });
  return newString;
};



// WEBPACK FOOTER //
// ../nx-components/src/ContextWrappers/contextHelper.js